import { render, staticRenderFns } from "./DashboardCompany.vue?vue&type=template&id=2247b04f&"
import script from "./DashboardCompany.vue?vue&type=script&lang=js&"
export * from "./DashboardCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports